import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import BASEURL from "../Utils/Baseurl";
import request from "graphql-request";
import {
  allAppointment,
  getAppointmentDetailByMaster,
  getAppointmentDetailByUser,
} from "../../lib/graphQL/graphQuery";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import { useLoading } from "../../context/LodingContext";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

const Appointment = () => {
  const [appointmentData, setApointmentpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const isUser = currentUser?.role;

  const { circleLoading, setCirleLoading } = useLoading();

  const fetcData = () => {
    setIsLoading(true);
    request(
      BASEURL,
      isUser.toLowerCase() == "manager"
        ? getAppointmentDetailByMaster
        : isUser.toLowerCase() == "employee"
        ? getAppointmentDetailByUser
        : isUser.toLowerCase() == "superuser"
        ? allAppointment
        : "",
      { id: currentUser?.id }
    )
      .then((res) => {
        setApointmentpData(
          isUser.toLowerCase() == "manager"
            ? res.getAppointmentDetailByMaster
            : isUser.toLowerCase() == "employee"
            ? res.getAppointmentDetailByUser
            : isUser.toLowerCase() == "superuser"
            ? res.allAppointment
            : []
        );
      })
      .catch((err) => console.error(err.message))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetcData();
  }, []);

  const appointmentListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S.NO",
        // flex: 1,
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Appointment ID",
        field: "appid",
        name: "Appointment ID",
        // flex: 1,
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Date",
        field: "scheduledDate",
        name: "Date",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Time",
        field: "time",
        name: "Time",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Name",
        field: "name",
        name: "Name",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Phone Number",
        field: "phoneNumber",
        name: "Phone Number",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Appointment Stage",
        field: "appointmentStage", 
        name: "Appointment Stage",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      
      {
        label: "Created By",
        field: "createdBy", // This is the field name you defined in your table columns
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created At",
        field: "createdAt", // This is the field name you defined in your table columns
        name: "Created At",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: appointmentData.reverse().map((val, index) => ({
      sno: index + 1,
      id: val.id,
      appid: val.appid,
      scheduledDate: val.scheduledDate,
      time: val.time,
      name: val.name,
      phoneNumber: val.phoneNumber,
      // status : val.status,
      appointmentStage: val.appointmentStage,
      createdBy: val.user.username,
      createdAt: val.createdAt ? val.createdAt.slice(0, 10) : "N/A",
    })),
  };

  const handleAddAppointmentForm = () => {
    navigate("/appointment/addappointment");
  };

  const onAppointmentForm = (e) => {
    if (e?.id) {
      navigate(`/appointment/addappointment?${e?.id}`);
    }
  };

  
const onCheck=(list)=>
  {
    console.log("id-c",list)
  }
  
const onDeleteALL=()=>
  {
    console.log("id-DELE")
  }

  return (
    <DashboardLayout>
      <TableComponent
      tableLoading={isLoading ? true : false }
      columns={appointmentListTable.columns}
      rowsData={appointmentListTable.rows}
      styles={{ paper: { padding: '16px' } }}
      head="Appointment List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onAppointmentForm}
      // onDelete={onDelete}
      onView={onAppointmentForm}
      onDeleteALL={onDeleteALL}
      addList={() => handleAddAppointmentForm()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Appointment List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleAddAppointmentForm()}
              >
                Add Appointment
              </MaterialButton>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={appointmentListTable.rows}
            columns={appointmentListTable.columns}
            onRowClick={onAppointmentForm}
          />
        )}

        {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
};

export default Appointment;
